import React from 'react'

import { Icon } from '../../UI'

const NotChangeableFieldLabel = ({
  isLabel = true,
  show = false,
  className = '',
  wrapperClassName = '',
  children,
  ...props
}) => {
  const notChangeableText = ' (This field cannot be changed later)'
  const labelClassName = `inline-block text-sm font-medium text-primary-100 mr-[6px] ${className}`

  return (
    <div className={`flex items-center mb-1 ${wrapperClassName}`}>
      {isLabel ? (
        <label className={labelClassName} {...props}>
          {children}
          {show ? notChangeableText : ''}
        </label>
      ) : (
        <span className={labelClassName} {...props}>
          {children}
          {show ? notChangeableText : ''}
        </span>
      )}

      {show && <Icon name="warning-triangle" color="#f79009" className="w-[24px] h-[24px]" />}
    </div>
  )
}

export default NotChangeableFieldLabel
